import React from "react";
import { RouteComponentProps, Link } from "@reach/router";
import { Container, Typography, Box, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const LoginError = (props: RouteComponentProps) => {
	return (
		<Container maxWidth="sm">
			<Typography variant="h5" component="div" align="center">
				<FormattedMessage
					id="minside.login_error.description"
					defaultMessage="Det har oppstått en feil under innlogging. Vennligst prøv igjen"
					description="Description of error"
				/>
				<Box mt={3}>
					<Button variant="outlined" color="primary" component={Link} to="/">
						<FormattedMessage
							id="minside.login_error.back_button_label"
							defaultMessage="Tilbake"
							description="Back button label"
						/>
					</Button>
				</Box>
			</Typography>
		</Container>)
};

export default LoginError;
